
import styled from 'styled-components';

import type { StyledComponentWithChildren } from '../../../types/styledComponent';

const BodyCard: StyledComponentWithChildren = styled.div`
  background-color: #7a8794;
  padding: 10px;
  margin-bottom: 15px;
`;
export default BodyCard;
